/* eslint-disable no-restricted-imports */
import { useState } from 'react';
import { Dropdown, MenuItem } from '@heathmont/moon-core-tw';
import useAgentData from '~/client/hooks/useAgentData';
import GameCurrencyOptions from './GameCurrencyOptions';
import GameCurrency from './useGameCurrencySelect/GameCurrency';
import CurrencyIcon from '../MobileGameView/CurrencyIcon';
import GameHeaderButton from '../MobileGameView/GameHeaderButton';
import Loader from '@/external/components/Loader';

type Props = {
  translations: Record<string, string>;
  isFunMode?: boolean;
  buttonClassName?: string;
  gameCurrencySelect: GameCurrency;
};

const GameCurrencySelect: FC<Props> = ({
  translations,
  isFunMode,
  buttonClassName,
  gameCurrencySelect,
}) => {
  const [isOpened, setIsOpened] = useState(false);
  const { isDisabled, options, selectedCurrency, handleChange } =
    gameCurrencySelect;
  const { isMobile } = useAgentData();

  if (isFunMode) {
    return null;
  }

  if (isMobile) {
    return (
      <>
        <GameHeaderButton
          onClick={() => setIsOpened(true)}
          className={buttonClassName || 'border border-beerus'}
        >
          {isDisabled || options.length === 0 ? (
            <Loader size="xs" />
          ) : (
            <CurrencyIcon currency={selectedCurrency} />
          )}
        </GameHeaderButton>
        <GameCurrencyOptions
          isOpened={isOpened}
          onClose={() => setIsOpened(false)}
          optionsList={options}
          translations={translations}
          onSelect={handleChange}
        />
      </>
    );
  }

  return (
    <div>
      <Dropdown
        value={selectedCurrency}
        onChange={handleChange}
        disabled={isDisabled}
        size="md"
      >
        <Dropdown.Trigger data-testid="in-game-currency-select">
          <span className="w-10 h-10 flex items-center justify-center bg-white/10 text-white rounded-full ">
            {isDisabled || options.length === 0 ? (
              <Loader size="xs" />
            ) : (
              <CurrencyIcon size="md" currency={selectedCurrency} />
            )}
          </span>
        </Dropdown.Trigger>
        <Dropdown.Options menuWidth="w-28">
          {options.map(({ name, value, selected }) => (
            <Dropdown.Option value={value} key={name}>
              {({ active }) => (
                <MenuItem isActive={active} isSelected={selected}>
                  <MenuItem.Title>{name}</MenuItem.Title>
                </MenuItem>
              )}
            </Dropdown.Option>
          ))}
        </Dropdown.Options>
      </Dropdown>
    </div>
  );
};

export default GameCurrencySelect;
